// extracted by mini-css-extract-plugin
var _1 = "styles-module__dataSection___zgMoI";
var _2 = "styles-module__label___xz5xq";
var _3 = "styles-module__section___nefNN";
var _4 = "styles-module__title___bkBFs";
export { _1 as "dataSection", _2 as "label", _3 as "section", _4 as "title" }
